import * as React from "react";
import { css } from "@nju/css";
import { IInvoice } from "@nju/data-access-portal-payment";
import { Box, Separator, Text } from "@nju/ui";
import { formatDate } from "@nju/utils";
import { MoreButton } from "../MoreButton";
import {
  formatPrice,
  getName,
  getPaymentColor,
  getPaymentStatus,
} from "../utils";

interface IMobileProps {
  invoice: IInvoice;
  onInvoiceSend: (id: string) => void;
  isLastRow: boolean;
}

export function Mobile({ invoice, onInvoiceSend, isLastRow }: IMobileProps) {
  const {
    invoiceNumber,
    product,
    documentType,
    invoiceType,
    correctiveInvoiceTime,
    invoiceTime,
    invoiceUrl,
    totalPrice,
    id,
    paymentStatus = "",
  } = invoice;

  const onSend = React.useCallback(() => {
    onInvoiceSend(id);
  }, [id, onInvoiceSend]);

  return (
    <tr className={styles.row({ isLastRow })}>
      <td>
        <Box display="flex" flexDirection="column">
          {formatDate(
            invoiceType === "CORRECTIVE" && correctiveInvoiceTime
              ? correctiveInvoiceTime
              : invoiceTime,
            false,
          )}
          <Text weight={{ "@onlyMobile": "bold" }}>{product.offeringName}</Text>

          <Separator size="xs" tone="invisible" />

          <Text weight="regular">{getName(documentType, invoiceType)}</Text>
          <Text className={styles.number()} weight="regular">
            {invoiceNumber}
          </Text>

          <Separator size="xs" tone="invisible" />

          <Text className={styles.price()} weight="bold">
            {formatPrice(+totalPrice.grossAmount)}
          </Text>
          <Text size="s" tone={getPaymentColor(paymentStatus)} weight="regular">
            {getPaymentStatus(paymentStatus)}
          </Text>
        </Box>
      </td>
      <td>
        <MoreButton invoiceUrl={invoiceUrl} onInvoiceSend={onSend} />
      </td>
    </tr>
  );
}

const styles = {
  number: css({
    wordBreak: "break-word",
  }),
  price: css({
    whiteSpace: "nowrap",
  }),
  row: css({
    display: "flex",
    justifyContent: "space-between",
    py: "$15",
    variants: {
      isLastRow: {
        false: {
          borderBottom: "1px solid $porcelain",
        },
      },
    },
  }),
};
